import { useMutation } from "@tanstack/react-query";
import api from "@lib/api/axios";
import { MutationConfig } from "@lib/api/query";
import { apiEnum } from "@shared/types/enums/apiEnum";

type PayLoadType = {
    uid: string;
    startDate: string;
    endDate: string
};

const updateTemp = async (payload: PayLoadType) => {
    const { data } = await api.post(apiEnum.updateTemp, payload);
    return data;
};

type UpdateTempType = {
    mutationConfig?: MutationConfig<typeof updateTemp>;
};

// export const optionsUpdateTemp = (payload: PayLoadType) => ({
//     queryFn: () => {
//         return updateTemp(payload);
//     },
// });

export const useUpdateTemp = ({ mutationConfig }: UpdateTempType) => {
    return useMutation({
        ...mutationConfig,
        mutationFn: updateTemp,
    });
};